import { camelCase, isNil, isEmpty as lodashIsEmpty } from 'lodash';

export function pascalCase(str: string): string {
  const res = camelCase(str);
  return res.charAt(0).toUpperCase() + res.slice(1);
}

export function underScoreCase(str: string): string {
  return str.replace(/([A-Z])/g, '_$1').toLowerCase();
}

/**
 * 深度转换驼峰式属性名为下划线格式
 * @param obj Object to convert
 */
export function camel2UnderScore(obj: any): any {
  const visited = new WeakSet();
  const convert = (obj: any): any => {
    if (visited.has(obj)) {
      return obj;
    }
    if (Array.isArray(obj)) {
      visited.add(obj);
      return obj.map(item => convert(item));
    }
    if (!isNil(obj) && obj.constructor === Object) {
      visited.add(obj);
      return Object.keys(obj).reduce((result, key) => {
        const underScoreKey = underScoreCase(key);
        result[underScoreKey] = convert(obj[key]);
        return result;
      }, {} as any);
    }
    return obj;
  };
  return convert(obj);
}

/**
 * 深度转换下划线属性名为驼峰式
 * @param obj Object to convert
 */
export function underScore2Camel(obj: any): any {
  const visited = new WeakSet();
  const convert = (obj: any): any => {
    if (visited.has(obj)) {
      return obj;
    }
    if (Array.isArray(obj)) {
      visited.add(obj);
      return obj.map(item => convert(item));
    }
    if (!isNil(obj) && obj.constructor === Object) {
      visited.add(obj);
      return Object.keys(obj).reduce((result, key) => {
        const camelKey = camelCase(key);
        result[camelKey] = convert(obj[key]);
        return result;
      }, {} as any);
    }
    return obj;
  };
  return convert(obj);
}

/**
 * 锁定和解锁页面滚动
 */
export const lockPageScroll = (lock: boolean) => {
  const lockScrollClass = 'odc-lock-scroll';
  if (lock) {
    document.querySelector('html')?.classList.add(lockScrollClass);
  } else {
    document.querySelector('html')?.classList.remove(lockScrollClass);
  }
};

/**
 * 计算根据外层圆环半径和角度位置，计算小球位置
 * @param {number} cx 圆心x
 * @param {number} cy 圆心y
 * @param {number} radius 圆环半径
 * @param {number} angle 角度位置
 * @returns {object} 小球位置
 */
export const getBallPosition = (cx = 960, cy = 960, radius = 960, angle = 300) => {
  const centerX = cx;
  const centerY = cy;
  const radian = (angle * Math.PI) / 180;
  return {
    x: centerX + radius * Math.cos(radian),
    y: centerY + radius * Math.sin(radian),
  };
};

/**
 * 复制文本到剪贴板
 * @param text 要复制的文本
 * @returns
 */
export function copyText(text: string): boolean {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  const result = document.execCommand('copy');
  document.body.removeChild(textarea);
  return result;
}